import { render } from "./AddFamily.vue?vue&type=template&id=0f15676c&scoped=true"
import script from "./AddFamily.vue?vue&type=script&lang=js"
export * from "./AddFamily.vue?vue&type=script&lang=js"

import "./AddFamily.vue?vue&type=style&index=0&id=0f15676c&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f15676c"]])

export default __exports__